import { uriConstants } from '../../store/constants'

const  generateRandomString = (num) => {
    const characters ='ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result1= ' ';
    const charactersLength = characters.length;
    for ( let i = 0; i < num; i++ ) {
        result1 += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result1;
}

const CLIENT_ID = "49f20bc8980432102cb921e76b919790";
const REDIRECT_URI =  uriConstants.API_URI+"/oauth/callback/kakao";

export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code`;

const NAVER_STATE = generateRandomString(5);
const NAVER_CLIENT_ID = "2vQXZFhbDAVORqK4WCEF";
const NAVER_REDIRECT_URI =  uriConstants.API_URI+"/oauth/callback/naver";
export const NAVER_AUTH_URL = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${NAVER_CLIENT_ID}&redirect_uri=${NAVER_REDIRECT_URI}&state=${NAVER_STATE};`;